import { render, staticRenderFns } from "./playlist.vue?vue&type=template&id=5d4aadd7&scoped=true&"
import script from "./playlist.vue?vue&type=script&lang=js&"
export * from "./playlist.vue?vue&type=script&lang=js&"
import style0 from "./playlist.vue?vue&type=style&index=0&id=5d4aadd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4aadd7",
  null
  
)

export default component.exports